@if (isCookiePanelVisible() | async) {
  <div
    class="cookie-panel"
    [@slideInOut]="{ value: true, params: { translateType: getAnimationTransformType() } }"
    [attr.data-qa-id]="'cookie-panel'"
  >
    <h1>We value your privacy</h1>
    <p class="small mb-xs">
      This website uses cookies. Please note we will not be using this information for any marketing activities but to
      help provide you with better service.
    </p>
    <p class="small mb-md">
      For more detailed information about the cookies we use, see our
      <span
        ><a
          [routerLink]="['/cookie-policy']"
          target="_blank"
          rel="noopener noreferrer"
          [attr.data-qa-id]="'cookie-policy-link'"
          >cookie policy<lib-open-link-icon class="icon-dark-blue icon-xxxs ml-xxxs"></lib-open-link-icon></a></span
      >.
    </p>
    <p class="text-align-right mb-xxs">
      <lib-button
        [attr.data-qa-id]="'allow-cookies'"
        class="mr-xs pt-md"
        styleName="button--secondary button--outline button--md btn"
        buttonText="Accept Cookies"
        bgColor="var(--secondary)"
        textColor="white"
        borderStyle="1px solid var(--secondary)"
        (clickEvent)="saveAndClose(true)"
      ></lib-button>
    </p>
    <p class="mb-xxs">
      <lib-button
        class="mr-xs"
        styleName="button--primary button--outline button--md"
        bgColor="#f9f9f9"
        textColor="#2a498c"
        borderStyle="1px solid #2a498c"
        buttonText="Decline Cookies"
        [attr.data-qa-id]="'essential-cookies'"
        (clickEvent)="saveAndClose(false)"
      ></lib-button>
    </p>
  </div>
}
